declare global {
  interface Window {
    apiPrefixPath?: string;
  }
}

export const SWTR_PREFIX =
  window.apiPrefixPath ?? "/api2";

export const URL_PREFIX = `${SWTR_PREFIX}`;

export const SWTR_PREFIX_V2 =
  window.apiPrefixPath ?? "/api1";

export const URL_PREFIX_V2 = `${SWTR_PREFIX_V2}`;
